import React, { useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import Widget from 'components/Widget'
import blueLogo from 'assets/logo/logo_blue.png'
import {Spin} from 'antd'
import PlanDetail from './components/PlanDetail'
import { useDispatch, useSelector } from 'react-redux';
import { DataGetAction } from '../../../redux/actions/http'




const Index = () => {



    const dispatch = useDispatch();
    const carePlanProps = useSelector(state => state.carePlanR)
    const patientInfo = JSON.parse(localStorage.getItem('userInfo')).patientInfo
    const {  healthCondition, dailyActivity, dailyActivityInfo, healthConditionInfo,fetchingPlanSpinner } = carePlanProps

    const fetchCarePlane = () => {
        dispatch(DataGetAction('fetchPatientCarePlane', '', 'fetchingCarePlane'))
    }
    useEffect(fetchCarePlane, [])



    return (
        <Layout>
          {fetchingPlanSpinner ? <Spin  size="large" /> :   <Widget
                title={<p className="gx-text-capitalize" style={{ color: '#707070' }}>Personal plan of <span className="gx-text-black gx-font-weight-bold">{patientInfo && patientInfo.firstName} {patientInfo && patientInfo.lastName}</span>  </p>}
                extra={<img src={blueLogo} alt="" width="100px" />}
            >
                <PlanDetail
                    planTitle="Health conditions"
                    planText={healthConditionInfo}
                    planQuestion={healthCondition} />
                <PlanDetail
                    planTitle="Daily Living Activities"
                    planText={dailyActivityInfo}
                    planQuestion={dailyActivity} />
            </Widget>}
        </Layout>
    )
}

export default Index
